import React from 'react'

const RulesDetails = ({selectedRule,closeModals}) => {
        const formatCurrency = (amount) => {
        if (amount === null || amount === undefined) return 'N/A'
        return new Intl.NumberFormat('en-CA', {
            style: 'currency',
            currency: 'CAD'
        }).format(amount)
    }
  return (
         <>
            <div className="modal fade show d-block" tabIndex="-1" style={{zIndex:"9999"}}  role="dialog">
                <div className="modal-dialog modal-xl modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header bg-primary text-white">
                            <h5 className="modal-title">Details: {selectedRule['province.name']}</h5>
                            <button type="button" className="btn-close btn-close-white" onClick={closeModals}></button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <div className="card h-100">
                                        <div className="card-header fw-bold">General Info</div>
                                        <div className="card-body">
                                            <p><strong>Regulatory Body:</strong> {selectedRule.regulatory_body_name} ({selectedRule.regulatory_body_acronym})</p>
                                            <p><strong>Key Legislation:</strong> {selectedRule.key_legislation}</p>
                                            <p><strong>Forms (Basic):</strong> {selectedRule.baisc_forms?.join(', ')}</p>
                                            <p><strong>Forms (Advanced):</strong> {selectedRule.advanced_legal_forms?.join(', ')}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <div className="card h-100">
                                        <div className="card-header fw-bold">Rent & Eviction</div>
                                        <div className="card-body">
                                            <p><strong>Rent Increase Notice:</strong> {selectedRule.rent_increase_notice_days} days</p>
                                            <p><strong>Increase Frequency:</strong> {selectedRule.rent_increase_frequency_days} days</p>
                                            <p><strong>Non-Payment Notice:</strong> {selectedRule.non_payment_notice_days} days</p>
                                            <p><strong>Eviction Filing Fee:</strong> {formatCurrency(selectedRule.eviction_filing_fee)}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 mb-3">
                                    <div className="card">
                                        <div className="card-header fw-bold">Workflow Stages</div>
                                        <div className="card-body p-0">
                                            <table className="table table-sm mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>Stage</th>
                                                        <th>Trigger</th>
                                                        <th>Action Type</th>
                                                        <th>Form</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {selectedRule.stages?.map((stage, idx) => (
                                                        <tr key={idx}>
                                                            <td>{stage.stage}</td>
                                                            <td>{stage.trigger.value} days after {stage.trigger.type}</td>
                                                            <td>{stage.action.type}</td>
                                                            <td>{stage.action.form || '-'}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <div className="card h-100">
                                        <div className="card-header fw-bold">Lease & Service</div>
                                        <div className="card-body">
                                            <ul className="list-group list-group-flush">
                                                <li className="list-group-item d-flex justify-content-between">
                                                    <span>Standard Lease Mandatory:</span>
                                                    <span>{selectedRule.lease_form_mandatory ? 'Yes' : 'No'}</span>
                                                </li>
                                                <li className="list-group-item d-flex justify-content-between">
                                                    <span>Electronic Service:</span>
                                                    <span>{selectedRule.allows_electronic_service ? 'Allowed' : 'No'}</span>
                                                </li>
                                                <li className="list-group-item d-flex justify-content-between">
                                                    <span>Online Dispute Portal:</span>
                                                    <a href={selectedRule.dispute_portal_url} target="_blank" rel="noreferrer">Link</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-6 mb-3">
                                    <div className="card h-100">
                                        <div className="card-header fw-bold">Meta Data</div>
                                        <div className="card-body">
                                            <p><strong>Timezone:</strong> {selectedRule.rules_meta_data?.timezone}</p>
                                            <p><strong>Currency:</strong> {selectedRule.rules_meta_data?.currency}</p>
                                            <div className="alert alert-secondary py-1 mt-2">
                                                <small><strong>Notes:</strong></small>
                                                <ul className="mb-0 ps-3">
                                                    {selectedRule.rules_meta_data?.notes?.map((note, i) => (
                                                        <li key={i}><small>{note}</small></li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={closeModals}>Close</button>
                        </div>
                    </div>
                </div>
            </div>
             {/* <div className="modal-backdrop fade show"></div> */}
             <style jsx>{`
                    .modal.show {
                        background-color: rgba(0, 0, 0, 0.5);
                    }
                `}</style>
         </>
  )
}

export default RulesDetails
     